import React from 'react';
import '../Style/Footer.css';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'en' ? 'ar' : 'en');
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© Alwaleed Stone | Privacy Policy · Cookies Policy</p>
          <p>+972 59-899-5512</p>
          <p><a href="mailto:info@waleedstone.com">info@waleedstone.com</a></p>
        <div className="social-icons">
        <a href="https://www.tiktok.com/@alwaleed.stone" target="_blank">
  <img src="/tiktok-line.svg" alt="Tiktok" />
</a>
<a href="https://www.facebook.com/alwaleed.stone" target="_blank">
  <img src="/facebook-fill.svg" alt="Facebook" />
</a>
<a href="#"><img src="/snapchat-line.svg" alt="Snapchat" /></a>
<a href="https://wa.me/972598995512" target="_blank">
  <img src="/whatsapp-line.svg" alt="WhatsApp" />
</a>

        </div>
    
      </div>
    </footer>
  );
};

export default Footer;
